/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Selfhost_TitleInputs */

const en_fc_online_selfhost_title = /** @type {(inputs: Fc_Online_Selfhost_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the web build yourself`)
};

/**
* | output |
* | --- |
* | "Run the web build yourself" |
*
* @param {Fc_Online_Selfhost_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_selfhost_title = /** @type {((inputs?: Fc_Online_Selfhost_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Selfhost_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_selfhost_title(inputs)
});
export { fc_online_selfhost_title as "fc.online.selfhost.title" }